import { createSelector, createFeatureSelector } from '@ngrx/store';
import {
	JobLocationState,
	jobLocationFeatureKey,
} from './job-location.reducer';
import { limitLatLngToFiveDigits } from '../job-location.utility';

export const getJobLocationState = createFeatureSelector<JobLocationState>(
	jobLocationFeatureKey
);

export const getLatLng = createSelector(
	getJobLocationState,
	(state: JobLocationState) =>
		state.latlng ? limitLatLngToFiveDigits(state.latlng) : undefined
);

export const getSubDivision = createSelector(
	getJobLocationState,
	(state) => state.subdivision
);
